import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../services/data.service';


import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { alert, confirm } from 'devextreme/ui/dialog';
import { NewNicaFormComponent } from '../../components/nica-form/new-nica-form.component';





@Component({
  selector: 'app-ana-registri-rifiuti',
  templateUrl: './ana-registri-rifiuti.component.html',
  styleUrls: ['./ana-registri-rifiuti.component.scss'],

})
export class AnaRegistriRifiutiComponent extends NicaMaster implements OnInit {
  @ViewChild('formAnagrafica', { static: false }) formAnagrafica: NewNicaFormComponent
  createRegRentri: boolean = false;
  constructor(
    private activateRoute: ActivatedRoute,
    public spinner: NgxSpinnerService,

    public apiservice: Apiservice,


    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,
    public rentriService: RentriService,
    private cdr: ChangeDetectorRef,
    private apiService: Apiservice

  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );
  }
  ngOnInit() {
    if (this.itemData) {
      this.setGlobalVariableFromParams(this.itemData[0])

    } else {


      this.activatedroute.queryParams.subscribe((params) => {

        this.currentTabId = params['currentTabId'],
          this.currentTabName = params['currentTabName']

        this.setGlobalVariableFromParams(params)


      });
    }
  }
  async formInitRegistro(event) {
    console.log(event)
    if (event.name === "formContentInitializzed" && event.component) {
      event.component.itemOption('RegistroRifiuti.registroRentri', 'disabled', event.formData.idSedeRentri == null)
      event.component.itemOption('RegistroRifiuti.allineaRegistro', 'disabled', event.formData.idSedeRentri == null)


      
      //NOTA ANTONIO 'Considerati i problemi di riprotocollazione, daremo la possibiltà di modificare i campi in caso di movimenti duplicati su RENTRI e sposteremo i controlli sul Backend in fase di salvataggio POST/PUT' 
      // if (event.component.dataSet['numeroUltimoProtocollo'] === null) event.component.dataSet['numeroUltimoProtocollo'] = event.component.dataSet['numeroUltimoProtocolloRentri']
      // if (event.formData && event.formData['isConsolidato'] == true) {
      //   event.component.itemOption('stampaProtocolli.numeroUltimoProtocollo', 'disabled', true);
      //   event.component.itemOption('stampaProtocolli.dataUltimoProtocolloStampato', 'disabled', true);
      // }

  //     if (event.formData.registroRentri && event.formData.idSoggetto && event.formData.idSedeRentri) {
  //       await this.apiService.GetApi(`rentri/registri/${event.formData.registroRentri}?idSoggetto=${event.formData.idSoggetto}&num_iscr_sito=${event.formData.idSedeRentri}&includiDatiUltimaRegistrazione=true`)
  //         .then((res) => {
  //           let disableUltimoProgressivo = !res['ultimo_progressivo'] ? false : true
  //           this.formAnagrafica.itemOption('stampaProtocolli.numeroUltimoProtocollo', 'disabled', disableUltimoProgressivo) // Nota Antonio 'Rimosso perché sta causando protocollazione su protocolli già scritti'

  //           let disableDataUltimoProtocolloStampato = !res['data_ora_registrazione_ultimo_movimento'] ? false : true
  //           this.formAnagrafica.itemOption('stampaProtocolli.dataUltimoProtocolloStampato', 'disabled', disableDataUltimoProtocolloStampato) // Nota Antonio 'Rimosso perché sta causando protocollazione su protocolli già scritti'
  //         }).catch((err) => null)
  //     }
     }
  }

  async formEventRegistri(event) {
    console.log('formEventRegistri', event)
    if (event.event === "allineaRegistroClick") {
      const guid = Math.random().toString().replace("0.", "")
      const selezionaRegistro = event.data.registroRentri === null
      const dataJson = event.data
      if (!dataJson) {
        return alert('Errore interno, riprovare', 'Attenzione')
      }
      let listaAttivitaSoggetto = await this.apiService.GetApi(`rentri/anagrafiche/GetSitoById?idSoggetto=${dataJson.idSoggetto}&num_iscr_sito=${dataJson.idSedeRentri}`).then((res) => res['attivita'])
      let listaAttivitaRSSoggetto = await this.apiService.GetApi(`rentri/anagrafiche/GetAllAttivitaRDSito?idSoggetto=${dataJson.idSoggetto}&num_iscr_sito=${dataJson.idSedeRentri}`)
      let listaRS = await this.apiService.GetApi(`rentri/anagrafiche/GetAllCodifiche?idSoggetto=${dataJson.idSoggetto}&domain=6`)
      const dataToSend = {
        guid,
        selezionaRegistro,
        isEdit: !selezionaRegistro,
        dataJsonRelated: dataJson,
        listaRS: listaRS,
        listaAttivitaSoggetto,
        listaAttivitaRSSoggetto
      }
      this.userComponentService.setNewPopUp(guid, 'AllineaRegistroRentriComponent', null, '1400', null, dataToSend, false, true, 'Registro Rentri', 'center', null)
      this.userComponentService.outputComponent.subscribe((res) => {
        if (res.guid === guid) {
          console.log(res)
          if (res.name === 'return') {
            this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
          }
          if (res.event === 'saved' && res.name === "emittedData") {
            if (this.formAnagrafica) this.formAnagrafica.dataSet['registroRentri'] = res['data']['identificativo']
            if (this.formAnagrafica) this.formAnagrafica.dataSet['numeroUltimoProtocollo'] = res['data']['ultimo_progressivo']
            if (this.formAnagrafica) this.formAnagrafica.dataSet['dataUltimoProtocolloStampato'] = res['data']['data_ora_registrazione_ultimo_movimento']

            let disableUltimoProgressivo = !res['data']['ultimo_progressivo'] ? false : true
            this.formAnagrafica.itemOption('stampaProtocolli.numeroUltimoProtocollo', 'disabled', disableUltimoProgressivo)

            let disableDataUltimoProtocolloStampato = !res['data']['data_ora_registrazione_ultimo_movimento'] ? false : true
            this.formAnagrafica.itemOption('stampaProtocolli.dataUltimoProtocolloStampato', 'disabled', disableDataUltimoProtocolloStampato)
            this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
          }
        }

      })
    }
    if (event.name == 'AssociaRegistroRentri') {


      const idSoggetto = event.data.idSoggetto
      const num_iscr_sito = event.data.idSedeRentri;
      if (!idSoggetto || !num_iscr_sito) {

        if (!num_iscr_sito) {
          alert("Manca allineamento nell'unità locale indicata", 'Attenzione')
        } else if (!idSoggetto) {

          alert("Manca l'unità locale!", 'Attenzione')
        }

        return
      }
      this.showRegistriRentri(idSoggetto, num_iscr_sito)


      return
    }
    this.formEvent(event)
  }

  formItemsEventCausali(event) {
    if (event.name == "onValueChanged") {
      if (event.campo.dataField == "sede_Descrizione") {
        this.formAnagrafica.formRefreshInputData('registroRentri', null);
        event.masterComponent.itemOption('RegistroRifiuti.registroRentri', 'disabled', event.formData.idSedeRentri == null)
        event.masterComponent.itemOption('RegistroRifiuti.allineaRegistro', 'disabled', event.formData.idSedeRentri == null)
      }

    }
  }

  async showRegistriRentri(idSoggetto, num_iscr_sito) {

    const data = await this.rentriService.getRegistri(idSoggetto, num_iscr_sito);

    const queryString = `?IdSoggetto=${idSoggetto}&num_iscr_sito=${num_iscr_sito}&$filter=(stato eq 'Attivo')`

    if (data['items'].length > 0) {

      let instancedDataGrid = {
        service: 'serviceRentriRegistriElenco',
        api: 'RentriOld/GetElencoRegistri',
        queryString: queryString,
        remoteOperation: true,
        rowAlternate: true,
        isEditable: false,
        isEditableNewRow: false,
        isEditableEditRow: false,
        isEditableDeleteRow: false,
        tableHeight: 600,
        tableWidth: 800,
        showFilter: false,
        selectionRowMode: 'single',
        idTable: 'ertwetretert4563546456456747r67658758756867',
        showToolbarTop: false,
        showToolbarBottom: false,
        isSearchable: false,

      }


      let guid = this.openComponentInPopUP('NicaDataGridComponent', [], instancedDataGrid, '800', 'Elenco Registri R.E.N.T.R.i', true, true)

      this.userComponentService.outputComponent.subscribe(currentOutput => {

        if (currentOutput.name == "gridHasInitialized" && currentOutput.guid == guid) {
          //currentOutput.component.refresh()
        }
        if (currentOutput.name == "onRowSelectionChange" && currentOutput.guid == guid) {

          const identificativo = currentOutput.data.identificativo

          this.formAnagrafica.formRefreshInputData('registroRentri', identificativo);

          this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)

        }
      })

    } else {

      confirm('Attenzione nessun registro creato o disponibile per la Unità locale scelta, Si vuole procedere creando questo registro sul  R.E.N.T.R.i?', 'Attenzione!').then(res => {

        this.createRegRentri = res


      })
    }
  }
}
